(function () {
    $ (function () {
        // отправка события клика по кнопкам соцсетей
        $ (document).on ("click", ".js-btn-socmedia", function (e) {
            const $btn = $ (this);
            
            $ (document).trigger ("uiEvent", [
                {
                    event: 'UI',
                    code: 'socmediaClick',
                    data: {
                        url: globalFunctions.escapeStr ($btn.attr ("href")),
                        code: globalFunctions.escapeStr ($btn.data ("code"))
                    }
                }
            ]);
        });
    })
} ());
